import i18next from 'i18next';
import * as React from 'react';
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useOnClickOutside } from '../../../../shared/hooks/use_on_click_outside/use_on_click_outside';
import { SearchDataContext } from '../../lib/search_data_context';
import { GuestsPopup } from '../guests_popup';

export const GuestsPicker = ({ formId }) => {
  const guestsPickerId = `${formId}-guests`;
  const guestsPopupId = `${guestsPickerId}-popup`;

  const [popupOpen, setPopupOpen] = useState(false);
  const wrapperRef = useRef(null);

  const { countGuests, childrenAges, withPet } = useContext(SearchDataContext);

  const countGuestsPrintable = useMemo(() => {
    let result = `${countGuests} ${i18next.t('adult', { count: countGuests })}`;
    const childrenCount = childrenAges?.length ?? 0;
    if (childrenCount) {
      result += `, ${childrenCount} ${i18next.t('child', { count: childrenCount })}`;
    }
    if (withPet) {
      result += ', питомец';
    }
    return result;
  }, [countGuests, childrenAges?.length, withPet]);

  const handleClickTextField = () => {
    setPopupOpen(!popupOpen);
  };

  const closePopup = useCallback(() => {
    setPopupOpen(false);
  }, []);

  useOnClickOutside(wrapperRef.current?.[0], closePopup);

  useEffect(() => {
    wrapperRef.current = $(`#${guestsPickerId}-wrapper`);

    const $datesRangeInput = $(`input#${formId}-dates-range`);
    $datesRangeInput.on('click', closePopup);

    return () => {
      $datesRangeInput.off('click', closePopup);
    };
  }, []);

  return (
    <div className={'search-data-popup__guests-picker'} id={`${guestsPickerId}-wrapper`}>
      <div className={'text_field'} onClick={handleClickTextField}>
        <div className={'text_field__wrapper text_field-size_default text_field-filled'}>
          <div className={'text_field__icon'}></div>
          <div className={'text_field__input_wrapper'}>
            <input className={'text_field__input'} name={'dates'} value={countGuestsPrintable} readOnly />
            <div className={'text_field__placeholder'}>Количество гостей</div>
          </div>
        </div>
      </div>
      <GuestsPopup id={guestsPopupId} open={popupOpen} onClose={closePopup} />
    </div>
  );
};
